import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PublicSharedModule } from '../public-shared/public-shared.module';
import { PublicRoutingModule } from './public-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { ReferralsCodeNavigateComponent } from 'src/app/public-website/public/components/referrals-code-navigate/referrals-code-navigate.component';

@NgModule({
  declarations: [
    ReferralsCodeNavigateComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PublicSharedModule,
    PublicRoutingModule,
    SharedModule
  ]
})
export class PublicModule { }
